import cache from './cache';
import flags from '../constants/flags';

import amex from '../images/amex.png';
import diners from '../images/diners.svg';
import elo from '../images/elo.svg';
import hipercard from '../images/hipercard.png';
import hiper from '../images/hiper.png';
import mastercard from '../images/mastercard.svg';
import master from '../images/mastercard.svg';
import visa from '../images/visa.svg';

export const getCardFlagImage = flag =>
  ({
    amex,
    diners,
    elo,
    hipercard,
    hiper,
    mastercard,
    master,
    visa,
  }[flag]);

export const getFlagMap = () => {
  return new Map([
    [
      flags.Amex,
      { name: 'American Express', image: getCardFlagImage(flags.Amex) },
    ],
    [flags.Diners, { name: 'Diners', image: getCardFlagImage(flags.Diners) }],
    [flags.Elo, { name: 'Elo', image: getCardFlagImage(flags.Elo) }],
    [
      flags.Hipercard,
      { name: 'Hipercard', image: getCardFlagImage(flags.Hipercard) },
    ],
    [
      flags.Mastercard,
      { name: 'MasterCard', image: getCardFlagImage(flags.Mastercard) },
    ],
    [flags.Visa, { name: 'Visa', image: getCardFlagImage(flags.Visa) }],
  ]);
};

const createPrefixTree = valuesByPrefix => {
  const initialNode = { transitions: {} };

  for (let prefix in valuesByPrefix) {
    let flag = valuesByPrefix[prefix];
    let node = initialNode;

    for (let char of prefix) {
      if (!node.transitions.hasOwnProperty(char)) {
        node.transitions[char] = { transitions: {} };
      }
      node = node.transitions[char];
    }

    if (node.hasOwnProperty('value')) {
      throw new Error(`Node can only have one value (${node.value})`);
    }

    node.value = flag;
  }

  return initialNode;
};

const sanitizeCardNumber = value => value.replace(/[^\d]/g, '');

const cachedCreatePrefixTree = cache(
  function safeCreatePrefixTree(valuesByPrefix) {
    try {
      return createPrefixTree(valuesByPrefix);
    } catch (err) {
      console.log('Failed to create prefix tree', err);
      return null;
    }
  },
  value => value,
);

const getCardFlagsByPrefix = flags => {
  const flagsByPrefix = {};

  Object.keys(flags).forEach(flagName => {
    const prefixes = flags[flagName];

    prefixes.forEach(prefix => {
      prefix = prefix.slice(0, -1);
      flagsByPrefix[prefix] = flagName.toLowerCase();
    });
  });

  return flagsByPrefix;
};

export const createFlagResolver = flags => {
  const flagsByPrefix = getCardFlagsByPrefix(flags);
  const tree = cachedCreatePrefixTree(flagsByPrefix);

  return function resolve(cardNumber) {
    cardNumber = sanitizeCardNumber(cardNumber);

    let node = tree;
    let value = node.value;

    for (let char of cardNumber) {
      if (!node.transitions.hasOwnProperty(char)) {
        break;
      }
      node = node.transitions[char];
      if (node.value) {
        value = node.value;
      }
    }
    return value;
  };
};
